import { CONTACT } from "@/data/content";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ink border-t border-gold/15 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          <div>
            <div className="font-display text-2xl tracking-wide text-cream mb-4">
              CANOPY <span className="text-gold">GROUNDS</span>
            </div>
            <p className="font-display italic text-gold/80 text-lg">
              Where every yard becomes a sanctuary
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-sm uppercase tracking-[0.25em] text-gold font-semibold">
              Get in Touch
            </p>
            <a
              href={`tel:${CONTACT.phone}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 text-cream/75 hover:text-gold transition-colors"
            >
              <Phone size={16} /> {CONTACT.phone}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email"
              className="flex items-center gap-3 text-cream/75 hover:text-gold transition-colors"
            >
              <Mail size={16} /> {CONTACT.email}
            </a>
            <div className="flex items-center gap-3 text-cream/75">
              <MapPin size={16} /> {CONTACT.location}
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm uppercase tracking-[0.25em] text-gold font-semibold">
              Explore
            </p>
            <div className="flex flex-col gap-3">
              <a href="#services" className="text-cream/75 hover:text-gold transition-colors">Services</a>
              <a href="#gallery" className="text-cream/75 hover:text-gold transition-colors">Gallery</a>
              <a href="#quote" className="text-cream/75 hover:text-gold transition-colors">Request a Quote</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-4 text-cream/40 text-sm">
          <p>© 2026 Canopy Grounds. All rights reserved.</p>
          <p>Premium Landscaping · Brantford, Ontario</p>
        </div>
      </div>
    </footer>
  );
};
